import Vue from 'vue'
import Router from 'vue-router'
// import Element from 'element-ui'

import HelloWorld from '@/components/HelloWorld'
import First from '@/components/views/First.vue'
import login from '../components/login.vue'
import home from '../components/home.vue'
import news from '../components/new.vue'
import news2 from '../components/new2.vue'
import more from '../components/more.vue'
import more2 from '../components/more2.vue'
import admin from '@/components/admin.vue'
import users from '@/components/admin/users.vue'
import editnews from '@/components/admin/editnews.vue'
import editnotices from '@/components/admin/editnotices.vue'
import editpicture from '@/components/admin/editpicture.vue'
import editpicture2 from '@/components/admin/editpicture2.vue'
import editpicture3 from '@/components/admin/editpicture3.vue'
import dictionary from '@/components/admin/dictionary.vue'
import navigation from '@/components/navigation.vue'
import navigatList from '@/components/navigat/list.vue'
import recommend from '@/components/admin/recommend.vue'
import official from '@/components/official.vue'
// import navigatDetail from '@/components/navigat/detail.vue'

// import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Router)
// Vue.use(Element)

const rout = new Router(
  {
    linkActiveClass: 'nav-menus-active',
    transitionOnLoad: true,
    hashbang: false,
    history: true,
    mode: 'history',
    routes: [
      {path: '/', name: '/', component: official},
      {path: '/first', name: 'First', component: First},
      {path: '/vue', name: 'HelloWorld', component: HelloWorld},
      {path: '/login', name: 'login', component: login},
      {path: '/home', name: 'home', component: home},
      {path: '/news', name: 'news', component: news},
      {path: '/news2', name: 'news2', component: news2},
      {path: '/more', name: 'more', component: more},
      {path: '/more2', name: 'more2', component: more2},
      {path: '/navigation', name: 'navigation', component: navigation},
      {path: '/official', name: 'official', component: official},
      {
        path: '/admin',
        name: 'admin',
        component: admin,
        redirect: 'users',
        children:
        [
          {path: '/editnews', name: 'editnews', component: editnews},
          {path: '/editnotices', name: 'editnotices', component: editnotices},
          {path: '/editpicture', name: 'editpicture', component: editpicture},
          {path: '/editpicture2', name: 'editpicture2', component: editpicture2},
          {path: '/editpicture3', name: 'editpicture3', component: editpicture3},
          {path: '/users', name: 'users', component: users},
          {path: '/dictionary', name: 'dictionary', component: dictionary},
          {path: '/navigatList', name: 'navigatList', component: navigatList},
          {path: '/recommend', name: 'recommend', component: recommend}
        ]
      }
      // {
      //   path: '/navigation',
      //   name: 'navigation',
      //   component: navigation,
      //   redirect: 'navigation',
      //   children:
      //   [
      //     {path: '/navigation', name: 'navigation', component: navigation},
      //     {path: '/navigatDetail', name: 'navigatDetail', component: navigatDetail}
      //   ]
      // }
    ]
  }
)

// 挂载路由导航守卫
rout.beforeEach((to, from, next) => {
  // to要访问的路径
  // from代表从哪个路径跳转而来
  // next是一个函数，表示放行
  // next() 放行  next('/login')强制跳转
  if (to.path === '/login' || to.path === '/navigation' || to.path === '/') return next()
  // 获取token
  const tokenStr = window.sessionStorage.getItem('token')
  // 若获取不到token，跳转到login页
  if (!tokenStr) return next('/login')
  next()
})

// 页面重新回到顶部
rout.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
})

export default rout



// WEBPACK FOOTER //
// ./src/router/index.js